import React from "react";
import { motion } from "framer-motion";
import { Award, Heart, Flame, Compass } from "lucide-react";

const journey = [
  { icon: Heart, label: "Called to healing", year: "2018" },
  { icon: Flame, label: "Reiki Master initiation", year: "2020" },
  { icon: Compass, label: "Past life regression training", year: "2022" },
  { icon: Award, label: "Reiki Grand Master", year: "2024" },
];

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-[#FAF9F6]">
      <div className="mx-auto max-w-7xl px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -inset-3 bg-[#8A9A86]/15 rounded-[2rem] -z-0 translate-x-4 translate-y-4" />
          <div className="relative aspect-[4/5] overflow-hidden rounded-[1.75rem]">
            <img
              src="https://customer-assets.emergentagent.com/job_aura-bliss-reiki/artifacts/rmjvy3r9_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2003_51_58%20PM.png"
              alt="Archana Tiwari"
              className="h-full w-full object-cover"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-7"
        >
          <div className="text-xs uppercase tracking-[0.28em] text-[#B35B47]">— Meet Archana</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#2C302E] leading-[1.05]">
            A keeper of <span className="italic">stillness</span>,<br />a channel for light.
          </h2>

          <div className="mt-8 space-y-5 text-[#5C605A] leading-relaxed text-lg">
            <p>
              I'm Archana Tiwari — Reiki Grand Master, past life regression
              therapist, and the gentle hands behind Aura Bliss Reiki. For over
              five years I've been a quiet companion to hundreds of souls on
              their way back to wholeness.
            </p>
            <p>
              My path began with a single Reiki initiation more than five years
              ago, and has since unfolded through thousands of meditations,
              long hours of silence, and a deepening conversation with the
              unseen. Along the way I've felt the soft presence of angels and
              guides around me — and learned to trust that gentle, knowing
              hum that always points the way.
            </p>
            <p>
              From those early days as a student, I've grown into a Reiki
              Grand Master, a past life regression therapist, and an
              intuitive astrology reader. Each modality is a different
              language for the same truth — that healing is remembering
              who we already are.
            </p>
            <p>
              My work is woven from ancient lineages and modern compassion. I
              believe every body holds wisdom, every wound holds a teacher, and
              every soul already knows the way home — sometimes it just needs
              a hand to hold along the path.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5">
            {journey.map((j, i) => {
              const Icon = j.icon;
              return (
                <div key={i} className="rounded-2xl border border-[#EAE5D9] bg-[#F4F1EB]/50 p-5">
                  <Icon className="h-5 w-5 text-[#B35B47]" />
                  <div className="font-serif text-2xl text-[#2C302E] mt-3">{j.year}</div>
                  <div className="text-xs text-[#8A8D86] mt-1 leading-snug">{j.label}</div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
